export default function PageHeading({ kicker, title, subtitle }) {
  return (
    <div className="mb-12 md:mb-16">
      {kicker && <p className="meta-label mb-4">{kicker}</p>}
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink leading-[0.95]">
        {title}
      </h1>
      {subtitle && (
        <p className="font-editorial text-xl md:text-2xl text-stone2e italic mt-5 max-w-2xl">
          {subtitle}
        </p>
      )}
    </div>
  );
}
